<template>
<div id="">
  <v-dialog v-model="show_dialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="secondary white--text">
        <h5>Newsletter</h5>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="show_dialog=false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <div class="text-center mb-4">
          <v-icon x-large color="primary" style="font-size:80px">fa-bell</v-icon>
        </div>
        <p class="mb-4">
          {{$store.state.website.newsletter_description}}
        </p>
        <v-text-field hide-details outlined v-model="email" clearable label="Email address"></v-text-field>
      </v-card-text>

      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="submitEmail" :disabled="!$helpers.validEmail(email)" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>

export default {
  name: "",
  created() {
    this.$eventBus.$on('show_newsletter', this.show)
  },
  data: () => ({
    show_dialog: false,
    loading: false,
    email: ''
  }),
  computed: {

  },
  methods: {
    show() {
      this.loading = false
      this.show_dialog = true
    },
    async submitEmail() {
      this.loading = true;
      this.$api({
        method: "POST",
        url: `/subscribe`,
        data: {
          email: this.email
        }
      })
      this.loading = false;
      this.show_dialog = false
    }
  }
}
</script>


<style lang="scss" scoped>

</style>
